import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { loadBalancerAPI } from '../../api/load-balancer';
import { useRecoilValue } from 'recoil';
import { authState } from '../../api/state';

interface DeviceExistsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onVerify: (code: string) => void;
  onOpenRecoveryModal?: () => void;
  isMenuClick?: boolean;
}

const DeviceExistsModal = ({ isOpen, onClose, onVerify, onOpenRecoveryModal, isMenuClick }: DeviceExistsModalProps) => {
  const [verificationCode, setVerificationCode] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();
  const authStateValue = useRecoilValue(authState);
  const location = useLocation();

  const handleOpenRecoveryCode = () => {
    if (onOpenRecoveryModal) {
      onOpenRecoveryModal();
    }
  };

  const handleVerify = async () => {
    if (!authStateValue?.user?.id) return;
    try {
      const response = await loadBalancerAPI.apiInstance.verifyQrCode(verificationCode, authStateValue?.user?.id);
      if (response.status === 200) {
        onVerify(verificationCode);
        onClose();
      } else {
        setErrorMessage('The authentication code is incorrect. Please try again.');
      }
    } catch (error) {
      setErrorMessage('The authentication code is incorrect. Please try again.');
    }
  };

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      handleVerify();
    }
  };

  const handleCancel = () => {
    setVerificationCode('');
    setErrorMessage('');
    onClose();
    if (location.pathname.includes('two-factor-auth')) {
      navigate('/home');
    }
  };

  return (
    <Dialog open={isOpen} fullWidth maxWidth="xs">
      <img src="google-authenticator.jpg" alt="authenticator-icon" style={{ width: '100%', maxWidth: '100vw' }} />
      <DialogTitle>Two-Factor Authentication</DialogTitle>
      <DialogContent>
        <DialogContentText>Enter the verification code generated by your mobile application</DialogContentText>
        <TextField
          required
          margin="dense"
          label="Enter code"
          type="text"
          fullWidth
          value={verificationCode}
          onChange={(e) => setVerificationCode(e.target.value)}
          error={!!errorMessage}
          helperText={errorMessage}
          onKeyDown={handleKeyDown}
        />
      </DialogContent>
      <DialogActions style={{ flexDirection: 'column' }}>
        <Button onClick={handleVerify} variant="contained">
          Verify code
        </Button>
        <div style={{ display: 'flex', marginTop: '20px', gap: '10px' }}>
          <Button onClick={handleCancel} color="primary">
            Cancel
          </Button>
          {!isMenuClick && (
            <Button onClick={handleOpenRecoveryCode} color="primary">
              Reset 2FA using Recovery Code
            </Button>
          )}
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default DeviceExistsModal;
